import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slide } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import { styled } from "@mui/system";
import { useRef, useState } from "react";
import BryxColors from "../../types/theme";
import BryxIcon from "../BryxIcon/BryxIcon";
import BryxActionMenuItem from "./BryxActionMenuItem";
import BryxNestedActionMenuItem from "./BryxNestedActionMenu";
export const BryxActionMenuTransitionTime = {
    appear: 250,
    enter: 250,
    exit: 150,
};
// If you need a visual for "what" these props are doing
// https://mui.com/material-ui/react-popover/#anchor-playground is a fantastic resource
export const getOriginPropsForElement = (el) => {
    const boundingBox = el?.getBoundingClientRect();
    let anchorOriginProps = { horizontal: "center" };
    let transformOriginProps = { horizontal: "center" };
    let isLeft = false;
    if (boundingBox?.left && boundingBox.right) {
        isLeft = boundingBox.x <= window.innerWidth / 2;
        anchorOriginProps = isLeft
            ? {
                horizontal: "right",
            }
            : {
                horizontal: "left",
            };
        transformOriginProps = isLeft
            ? {
                horizontal: "left",
            }
            : {
                horizontal: "right",
            };
    }
    return {
        anchorOriginProps,
        transformOriginProps,
        isLeft,
    };
};
const BryxActionMenu = styled(({ className, id, options, stopPropagation }) => {
    const buttonId = `${id}-button`;
    const menuId = `${id}-menu`;
    const buttonElement = useRef(null);
    const menuChildContainerRef = useRef(null);
    const [open, setOpen] = useState(false);
    const { anchorOriginProps, transformOriginProps, isLeft } = getOriginPropsForElement(buttonElement.current);
    const buildChildrenFromOptions = (options) => {
        return options.map((option, index) => {
            if (option.children) {
                return (_jsx(BryxNestedActionMenuItem, { label: option.content, parentMenuOpen: open, stopPropagation: stopPropagation, children: buildChildrenFromOptions(option.children) }, index));
            }
            return (_jsx(BryxActionMenuItem, { content: option.content, onClick: (e) => {
                    option.callback?.();
                    setOpen(false);
                    stopPropagation && e.stopPropagation();
                } }, index));
        });
    };
    return (_jsxs("div", { className: className, children: [_jsx(IconButton, { ref: buttonElement, "aria-label": "More options", id: buttonId, "aria-controls": open ? menuId : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", onClick: (e) => {
                    setOpen(true);
                    stopPropagation && e.stopPropagation();
                }, disableRipple: true, children: _jsx(BryxIcon, { iconName: "more_vert", lgIconSize: true }) }), _jsx(Menu, { id: menuId, anchorEl: buttonElement.current, open: open, disableAutoFocus: true, disableAutoFocusItem: true, onClose: () => setOpen(false), variant: "menu", anchorOrigin: {
                    vertical: "top",
                    ...anchorOriginProps,
                }, transformOrigin: {
                    vertical: "top",
                    ...transformOriginProps,
                }, MenuListProps: {
                    "aria-labelledby": buttonId,
                }, PaperProps: {
                    style: {
                        width: "167px",
                    },
                }, children: _jsx("div", { ref: menuChildContainerRef, style: { pointerEvents: "all" }, children: _jsx(Slide, { direction: isLeft ? "right" : "left", container: menuChildContainerRef.current, timeout: BryxActionMenuTransitionTime, in: open, enter: true, exit: true, mountOnEnter: true, children: _jsx("div", { children: buildChildrenFromOptions(options) }) }) }) })] }));
})(({ theme, type = "standard" }) => {
    const styles = type === "data-grid"
        ? {
            "& > .MuiButtonBase-root > .MuiSvgIcon-root": {
                height: "18px",
            },
        }
        : {};
    return {
        overflow: "hidden",
        width: "min-content",
        "& > .MuiButtonBase-root": {
            color: BryxColors.specialColor(theme.palette.mode).greyButGray,
            padding: 0,
        },
        ...styles,
    };
});
export default BryxActionMenu;
